import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { getAccessMgmtEndPoint } from '../utils';
import AccessPreviewTab from '../previewAccessMgmt/previewaccessmgmt';
import { useEffect, useState } from 'react';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { ReactComponent as Add } from '../../../icons/AddNew.svg';
import { ReactComponent as Print } from '../../../icons/printNew.svg';
import ExcelService from '../../../services/excel';
import AddAccessManagementScreen from '../addScreen/addScreen';
import axios from 'axios';
import {
    setCountryCodesList,
    setLocationData,
    setLungaguesData,
    setTimeZonesData,
} from '../accessmgmtReducer';
import notify from '../../../services/toasterService';
import loader from '../../../assets/loader.gif';
import { setSelectedRecrdsExport } from '../../contactTabs/contactReducer';
import { ReactComponent as Download } from '../../../icons/download.svg';
import AddFileUploadScreen from '../addScreen/fileUpload';
import UserMngmtGrid from '../../grid/access-mngmt-grid/access-mngmt-grid';

const UserManagement = () => {

    let gridHieght = 'calc(100vh - 390px)';
    let selectedTab = 'Users';
    const dispatch = useDispatch();
    const [addScreen, setAddScreen] = useState(false);
    const [addScreenTabName, setAddScreenTabName] = useState(null);

    const [screenType, setScreenType] = useState('excelUpload');

    const [userLoginData, SetUserLoginData] = useState<any>();

    const selectedRowData = useSelector(
        (state: RootState) => state.gridReducer.selectedRowData
    );
    const loaderStatus = useSelector(
        (state: RootState) => state.accessMgmtReducer.isLoaderShow
    );

    const userManagementData = useSelector(
        (state: RootState) => state.accessMgmtReducer.userAccessData
    );

    const [addFileScreen, setFileUploadAddScreen] = useState(false);

    const seletedDataToExport = useSelector(
        (state: RootState) => state.contactReducer.selectedRecordsForExport
    );

    useEffect(() => {
        getUserSelectionFields('Default Language');
        getUserSelectionFields('Default TimeZone');
        getUserSelectionFields('Reclaim Centers List');
        getUserSelectionFields('Default Country');
    }, [selectedRowData]);

    const excelExport = () => {
        console.log(seletedDataToExport);
        if (
            seletedDataToExport !== null &&
            seletedDataToExport !== undefined &&
            seletedDataToExport.length > 0
        ) {
            ExcelService.exportAsExcel('acm', selectedTab, seletedDataToExport);
            dispatch(setSelectedRecrdsExport([]));
        } else {
            ExcelService.exportAsExcel('acm', selectedTab, userManagementData);
        }
    };

    const handlePopupActionLocation = (selectedTabName: any) => {
        setAddScreen(true);
        setAddScreenTabName(selectedTabName);
    };

    const getUserSelectionFields = async (fieldName: any) => {
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        await axios.get(getEndPointUrl).then(
            (res) => {
                if (fieldName === 'Default Language') {
                    dispatch(setLungaguesData(res.data));
                } else if (fieldName === 'Default TimeZone') {
                    dispatch(setTimeZonesData(res.data));
                } else if (fieldName === 'Reclaim Centers List') {
                    dispatch(setLocationData(res.data));
                } else if (fieldName === 'Default Country') {
                    dispatch(setCountryCodesList(res.data));
                }
            },
            (err) => {
                notify('Failed to fetch data', 'error');
            }
        );
    };

    const excelImport = (selectedTabName: any) => {
        console.log('');
        setFileUploadAddScreen(true);
        setAddScreenTabName(selectedTabName);
    };
    return (
        <div>
            {addScreen && (
                <AddAccessManagementScreen
                    addScreen={addScreen}
                    setAddScreen={setAddScreen}
                    tabName={addScreenTabName}
                />
            )}
            {addFileScreen && (
                <AddFileUploadScreen
                    addScreen={addFileScreen}
                    setFileUploadAddScreen={setFileUploadAddScreen}
                    tabName={addScreenTabName}
                    screenType={screenType}
                />
            )}
            <div className="col-sm-12 col-md-12 col-lg-12 pt-1 pl-2">
                <div className="col-sm-6 pl-0 pt-4">
                    <p className="access-mgmt-title mb-2">Users</p>
                </div>
                <div className="col-sm-6 pr-0">
                    <ButtonComponent
                        type="button"
                        className="iconCopy float-right ml-1"
                        alt="Add "
                        onClick={() => handlePopupActionLocation(selectedTab)}
                    >
                        <Add />
                    </ButtonComponent>

                    <ButtonComponent
                        className="iconCopy float-right ml-1"
                        alt="Export"
                        onClick={() => excelExport()}
                    >
                        <Print />
                    </ButtonComponent>
                    <ButtonComponent
                        className="iconCopy float-right ml-1"
                        onClick={() => excelImport('ExcelUpload')}
                    >
                        <Download />
                    </ButtonComponent>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 pl-2">
                <div className="control-pane">
                    <div className="control-section tab-control-section">
                        <div className="col-sm-12 col-md-12 col-lg-12 ">
                            <div
                                className="col-sm-8 col-md-12 col-lg-8 pl-0 pr-4 "
                                style={{ width: '75%' }}
                            >
                                <>
                                    {loaderStatus ? (
                                        <div className="LoadImg">
                                            <img
                                                className="loaderClass"
                                                src={loader}
                                            />
                                        </div>
                                    ) : (
                                        <div className="access-mgmt-text-transform">
                                            <UserMngmtGrid
                                                height={gridHieght}
                                                width={'100%'}
                                            />
                                        </div>
                                    )}
                                </>
                            </div>
                            {selectedRowData && selectedRowData.length > 0 ? (
                                <div
                                    className="col-sm-4 col-md-12 col-lg-4 pl-4 "
                                    style={{ width: '25%', height: gridHieght }}
                                >
                                    <AccessPreviewTab />
                                </div>
                            ) : (
                                <div
                                    className="col-sm-4 col-md-12 col-lg-4 pl-4 "
                                     style={{ width: '25%', height: gridHieght }}
                                >
                                    <div className="access-preview d-flex align-items-center">
                                        <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                            <p className="preview-msg">
                                                Select user to view details
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserManagement;
